// @flow

export const MAX_PANE_COUNT = 5;
